<template>
  <div class="operations-table">
    <horizontal-table>
      <table class="h-table">
        <tr v-for="column in columns" :key="column.id">
          <th
            class="h-table__col-title"
            :class="{
              active: sortBy === column.sort,
            }"
            @click="sort(column.sort)"
          >
            {{ column.titleSm || column.title }}
          </th>

          <template v-for="date in dates">
            <!-- Колонка резюме -->
            <template v-if="date.resume">
              <cell :key="date.unique" :column="column" :date="date" :edit="edit" @toggle="date.open = !date.open" />
            </template>

            <template v-if="!date.resume || date.open">
              <cell
                v-for="operation in date.operations"
                :key="operation.unique"
                :column="column"
                :date="date"
                :operation="operation"
                :edit="edit"
                :can-remove="canRemove"
                @remove="remove(operation)"
                @restore="restore(operation)"
              />
            </template>
          </template>
        </tr>
      </table>
    </horizontal-table>
  </div>
</template>

<script>
import HorizontalTable from "@/components/horizontal-table";
import Cell from "./cell-sm";

export default {
  components: { HorizontalTable, Cell },
  props: ["dates", "sortBy", "edit", "canRemove", "columns"],
  methods: {
    sort(column) {
      if (!column) return;
      this.$emit("sort", column);
    },
    remove(transaction) {
      this.$emit("remove", transaction);
    },
    restore(transaction) {
      this.$emit("restore", transaction);
    },
  },
};
</script>
<style lang="scss" scoped>
.operations-table {
  th {
    width: 85px;
    min-width: 85px;
    height: 44px;
  }
}
</style>
